import type { NotificationTemplateDTO } from '@today/types'
import { DEFAULT_TEMPLATE_CHANNEL_LABELS, type MessagePickerOption } from '@today/ui-domain'

/** The picker's two non-template choices (TO-140 REQ-106 / REQ-108). */
export enum MessageChoice {
	/** The offer holds a custom body (shown as "Custom"). */
	CUSTOM = '__custom__',
	/** Start a custom message from an empty editor ("Write custom"). */
	WRITE_CUSTOM = '__write_custom__',
}

/** The primary language subtag of a locale tag (`es-ES` → `es`). */
export const languageOf = (locale: string): string => locale.split('-')[0]?.toLowerCase() ?? ''

/**
 * Step 3's picker (TO-140 offer-notification-message REQ-106): the active templates
 * of the offer's language, in library order, each `<name> · <channel>`, then "Write custom".
 */
export function pickerOptions(
	templates: readonly NotificationTemplateDTO[],
	offerLocale: string,
): MessagePickerOption[] {
	const language = languageOf(offerLocale)
	return [
		...templates
			.filter((t) => t.isActive && t.locale === language)
			.map((t) => ({ value: t.id, label: `${t.name} · ${DEFAULT_TEMPLATE_CHANNEL_LABELS[t.channelType]}` })),
		{ value: MessageChoice.WRITE_CUSTOM, label: 'Write custom' },
	]
}
